
import React, { Component } from 'react';
import {Row, Col} from '../3rdparty/react-pure-grid';
import { slide as Menu } from 'react-burger-menu'
import { NavLink } from 'react-router-dom';
import Session from '../services/session';

import flagEng from '../assets/images/flag-eng.png';
import flagRus from '../assets/images/flag-rus.png';
import flagEsp from '../assets/images/flag-esp.png';

import i from '../imports';

const submenuItemStyle = {
    fontSize: 18,
    textDecoration: "none",
    padding: 20,
    fontWeight: "bold"
}

class NavBar extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
          hoverIndex: -1,
          toolTipHover: false
        }
    }

    onHover = (index) => {
        this.setState({ hoverIndex: index });
    }

    mouseOut = (index) => {
        this.setState({ hoverIndex: -1 });
    }
    
    renderSubitems = (parentItem) => {
      if(!parentItem.children) {
        return null;
      }

      return (
        <div style={{padding: 10}}>{
          parentItem.children.map((item, index) => 
            <NavLink className="subitem-link" key={index} style={submenuItemStyle} to={`/${Session.language}${item.path}`}>{Session.model.navigation[parentItem.name + "Children"][item.name]}</NavLink>
          )}
        </div>
      );
    }

    render() {      
      return (
          <div style={{display: 'table-row'}}> { this.props.items.filter( item => !item.hidden ).map( (item, index) =>
              <i.Tooltip trigger={item.children && item.children.length > 0 ? "mouseenter focuse" : "manual"} key={index} html={this.renderSubitems(item)} position="bottom" interactive arrow distance={18} theme="light" useContext={true}>
                <NavLink style={{textDecoration: 'none', color: 'black'}} to={`/${Session.language}${item.path}`}>
                  <div onMouseOut={() => this.mouseOut(index)} onMouseOver={ () =>  this.onHover(index) } key={ index } style={ Object.assign({}, {display: 'table-cell'}, this.state.hoverIndex !== index ? StyleNormal : StyleHover) }>
                    {item.text}
                  </div>
                </NavLink>                
              </i.Tooltip>                
            )}
          </div>
      );
    };
}

const NavBarMobile = (props) => {
  
  let renderSubitems = (parentItem) => {
    if (!parentItem.children) {
      return null;
    }
    return (
      <div>{
        parentItem.children.map((m, index) => 
          <NavLink key={index} style={{textDecoration: 'none'}} to={`/${Session.language}${m.path}`}><Row className='mobile-link' key={index}><Col align='left' style={{padding: 10, paddingLeft: 40}}>{Session.model.navigation[parentItem.name + "Children"][m.name]}</Col></Row></NavLink>
        )}
      </div>
    );
  }

  return (
    <Menu right styles={MobileMenuStyle} >
      <Row className="child-col-h100pс" style={{
          height: "calc(100% - 180px)"
        }}>
        <Col style={{height: "100%"}}>
          <div style={{/*hidden-scroll-wrapper*/ height: "100%", overflow: "hidden" }}>
          <div style={{
              /*hidden-scroll*/
            	overflowY: "scroll",
              maxHeight: "100%",
              width: "100%",
              paddingRight: 45
          }}>
          {props.items.filter( item => !item.hidden ).map( (m, index) => {
            return (
              <div>
                <NavLink style={{textDecoration: 'none'}} to={`/${Session.language}${m.path}`}><Row className='mobile-link' key={index}><Col align='left' style={{padding: 10}}>{m.text}</Col></Row></NavLink>
                {renderSubitems(m)}
              </div>
            );
          }
          )}
          </div>
          </div>
        </Col>
      </Row>
      <Row style={{marginTop: 20}}>
          <Col>
            <NavFlags />
          </Col>
      </Row>
    </Menu>
  );
}

const MobileMenuStyle =  {
    bmBurgerButton: {
      position: 'fixed',
      width: '20px',
      height: '20px',
      right: '10px',
      top: '20px'
    },
    bmBurgerBars: {
      background: '#373a47'
    },
    bmCrossButton: {
      height: '24px',
      width: '24px'
    },
    bmCross: {
      background: '#bdc3c7'
    },
    bmMenu: {
      background: 'white',
      padding: '2.5em 1.5em 0',
      fontSize: '1.15em',
      overflow: 'none',
      height: "100%"
    },
    bmMorphShape: {
      fill: '#373a47'
    },
    bmItemList: {
      color: '#b8b7ad',
      padding: '0.8em'
    },
    bmOverlay: {
      background: 'rgba(0, 0, 0, 0.3)'
    }
  }
  

const StyleNormal = {
    paddingLeft: 22,
    paddingRight: 22,
    paddingTop: 5,
    paddingBottom: 5,
    backgroundColor: 'White',
    borderBottom: '4px solid white',
    transition: 'all 1s',
    fontSize: 20,
    fontWeight: 'normal',
    textTransform: 'uppercase'
}

const StyleHover = {
    ...StyleNormal,
    color: 'red',
    borderBottom: '4px solid red',
    cursor: 'pointer'
}

const NavFlags = () => (
    <span>
        <NavLink style={{textDecoration: 'none'}} to="/ru/"><img src={flagRus} style={Style.flagStyle} className='flag' alt="rus"/> </NavLink>
        <NavLink style={{textDecoration: 'none'}} to="/en/"><img src={flagEng} style={Style.flagStyle} className='flag' alt="eng"/> </NavLink>
        <NavLink style={{textDecoration: 'none'}} to="/es/"><img src={flagEsp} style={Style.flagStyle} className='flag' alt="esp"/> </NavLink>
    </span>
)

const Style = {
    flagStyle: {
      marginRight: 0,
      marginLeft: 10,
      marginTop: 10
    }
  }

export { NavBar, NavBarMobile, NavFlags };